const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL !== undefined ? process.env.REACT_APP_API_BASE_URL : 'http://localhost:8080',
  BASIC_AUTH: process.env.REACT_APP_API_BASIC_AUTH || 'dXNlcjpiOGZlOWRkOS04ZGQ1LTQ5ODgtOGJjMy1mYjQyZGUzMGQwOTY=',
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  ENDPOINTS: {
    AUTH: {
      REQUEST_OTP: '/api/auth/request-otp',
      VERIFY_OTP: '/api/auth/verify-otp'
    },
    STAFF_AUTH: {
      LOGIN: '/api/staff/auth/login',
      SET_PASSWORD: '/api/staff/auth/set-password'
    },
    CUSTOMER: {
      CREATE_TICKET: '/customer-ticket'
    },
    MENU: {
      GET_ITEMS: '/api/menu-items'
    },
    ORDERS: {
      PLACE_ORDER: '/api/orders',
      GET_STATUS: (orderId) => `/api/orders/${orderId}/status`,
      GENERATE_BILL: '/api/orders/generate-bill',
      GET_BY_CUSTOMER_TICKET: (customerTicketId) => `/api/orders/customer-ticket/${customerTicketId}`,
      GET_CUSTOMER_TICKET_HISTORY: '/api/orders/customer-tickets'
    },
    WORK_TICKETS: {
      GET_PENDING: (type) => `/api/work-tickets/pending/${type}`,
      COMPLETE_TICKET: (ticketId) => `/api/work-tickets/${ticketId}/complete`
    }
  }
};

// Debug: Log the current API configuration
console.log('🔧 API Configuration:', {
  BASE_URL: API_CONFIG.BASE_URL,
  ENVIRONMENT: API_CONFIG.ENVIRONMENT,
  ENV_VAR: process.env.REACT_APP_API_BASE_URL
});

export const getHeaders = (includeAuth = false, customHeaders = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...customHeaders
  };
  
  if (includeAuth) {
    const token = localStorage.getItem('authToken');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  
  return headers;
};

export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export default API_CONFIG;
